import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  InventoryTableRequestParams,
  ItemBasicDetailsInitialState
} from "../interface";
import { getInventoryTableData } from "src/api/bi";
import { ITEM_TAGS } from "src/config/constants/genericConstants";

export const fetchInventoryTableData = createAsyncThunk(
  "itemDetails/fetchInventoryTableData",
  (payload: InventoryTableRequestParams, { getState }) => {
    const { itemBasicDetails } = getState() as {
      itemBasicDetails: ItemBasicDetailsInitialState;
    };
    const { data: itemBasicDetailsData } = itemBasicDetails;
    payload.isRandomWeightItem = itemBasicDetailsData?.tags?.includes(
      ITEM_TAGS.RANDOM_WEIGHT
    );
    return getInventoryTableData(payload);
  }
);
